import React, { useState, useEffect } from "react";
import PaymentsTable from "./PaymentsTable";

const PendingPaymentsTable = ({ jsonData }) => {
  const [pendingPayments, setPendingPayments] = useState([]);
  const currentEpoch = jsonData?.current_epoch;

  useEffect(() => {
    const filteredPayments = jsonData?.cws.flatMap((wallet) =>
      wallet.transactions.scheduled
        .filter((payment) => payment.deadline >= currentEpoch)
        .map((payment) => ({
          address: wallet.Address,
          name: wallet.Name,
          deadline: payment.deadline,
          payee: payment.tx.payee,
          description: payment.tx.description,
          amount: payment.tx.value,
        }))
    );

    const sortedPayments = filteredPayments?.sort((a, b) => {
      if (a.address < b.address) return -1;
      if (a.address > b.address) return 1;
      if (a.deadline < b.deadline) return -1;
      if (a.deadline > b.deadline) return 1;
      if (a.amount < b.amount) return -1;
      if (a.amount > b.amount) return 1;
      return 0;
    });

    setPendingPayments(sortedPayments);
  }, [jsonData, currentEpoch]);

  if (!jsonData) {
    return null;
  }

  return <PaymentsTable payments={pendingPayments} />;
};

export default PendingPaymentsTable;
